import { type IWithStagingStatus } from '@Model';
import {
    Awaitable,
    EnumFilterExpressionOperation,
    EnumOperation,
    EnumStatus,
    type FilterCondition,
    type FilterExpression,
    type IIdWithDisplay,
    type IWithStatus,
    type Index,
    type ListInfo,
    type ListRequest,
} from '@synqo/frontend-component-library';
import { useCallback } from 'react';

const emptyFilterExpression: FilterExpression = { operation: EnumFilterExpressionOperation.And, filters: [] };
export const stagingStatusColumn: Index<IWithStagingStatus> = 'staging_status';
export const statusColumn: Index<IWithStatus> = 'status';

const statusFilter: FilterCondition = {
    field: statusColumn,
    value: EnumStatus.Draft.toString(),
    operator: EnumOperation.Equal,
};
const stagingStatusFilter: FilterCondition = {
    field: stagingStatusColumn,
    value: '',
    operator: EnumOperation.NotEqual,
};

export function useLoadStagingObjects<T extends IIdWithDisplay & IWithStatus & IWithStagingStatus>(
    loader: (l: Readonly<ListRequest>) => Awaitable<ListInfo<T>>,
) {
    return useCallback(
        (lr: Readonly<ListRequest>) => {
            const userFilterExpression: FilterExpression = lr.filter_columns ?? emptyFilterExpression;

            return loader({
                ...lr,
                filter_columns: {
                    operation: EnumFilterExpressionOperation.And,
                    filters: [statusFilter, stagingStatusFilter, userFilterExpression],
                },
            });
        },
        [loader],
    );
}
